var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdFs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4130_212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7923 22.8547H2.784V3.9264H22.7923V22.8547Z",
    fill: "#F1511B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2189 22.8547H25.2077V3.9264H45.2189V22.8547Z",
    fill: "#80CC28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7914 44.0746H2.784V25.1462H22.7914V44.0746Z",
    fill: "#00ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2189 44.0746H25.2077V25.1462H45.2189V44.0746Z",
    fill: "#FBBC09"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4130_212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdFs);
export default __webpack_public_path__ + "static/media/ADFs.f822df423b90833207a6750e811364fe.svg";
export { ForwardRef as ReactComponent };